import React from "react"
import Helmet from 'react-helmet';
export default ({
    faqs
}) => {
    const mainEntity = [];
    if(faqs){
        faqs.forEach(faq => {
            const questionItem = {
                "@type": "Question",
                "name": faq.faq_question_rc,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": faq.faq_answer_rc
                }
            };
            mainEntity.push(questionItem);
        })
    };
    
    const FAQSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": mainEntity
      }
    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(FAQSchema, null, '\t')}
            </script>
        </Helmet>
    )
}